import './App.css';
import './index.js';

function App() {
  return (
    <div className="App">
      <h1>Under Construction. Coming soon.</h1>
    </div>
  );
}

export default App;
